var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagFr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(4357 3559)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-fr",
    transform: "translate(-4357 -3559)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17588",
    "data-name": "Groupe 17588",
    transform: "translate(13405.983 8759.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17587",
    "data-name": "Groupe 17587",
    transform: "translate(-9049.323 -5200.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17586",
    "data-name": "Groupe 17586",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 7.447,
    height: 20.986,
    transform: "translate(0)",
    fill: "#0077ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 7.447,
    height: 20.986,
    transform: "translate(7.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 7.447,
    height: 20.986,
    transform: "translate(14.893)",
    fill: "#de0404"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFr);
export default __webpack_public_path__ + "static/media/flag-fr.495233b1f9d71a981c20a776474f29eb.svg";
export { ForwardRef as ReactComponent };